import { MainInner } from "@/styles/global";
import { DetailsLightCss, h2 } from "@/styles/typography";
import styled from "styled-components";
import { Link as GatsbyLink } from "gatsby";

const Inner = styled(MainInner)`
  gap: 24px;
`;

const Title = styled(h2)`
  color: ${({ theme }) => theme.colors.coreLight};
`;

const LinksWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-flow: column wrap;
    row-gap: 16px;
    column-gap: 56px;
    max-height: 130px;
    max-width: 820px;
    width: fit-content;
  }
`;

const LinkItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 18px;
    height: 18px;
    transition: all 0.3s ease-in-out;
  }

  &:hover {
    svg {
      transform: translateX(10px);
    }
  }
`;

const Link = styled(GatsbyLink)`
  ${DetailsLightCss}
  text-decoration: none;
  color: ${({ theme }) => theme.colors.coreLight};
  word-break: no-break;
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: text-decoration-color 0.3s ease;

  &:hover {
    text-decoration-color: ${({ theme }) => theme.colors.coreLight};
  }
`;

const S = {
  Inner,
  Title,
  LinksWrapper,
  LinkItem,
  Link,
};

export default S;
